import React, { useCallback } from 'react';
import styled from 'styled-components';
import ICellProps from '../ICellProps';


interface IProps extends ICellProps {
  onChange: (value: string) => void;
  field: any;
  readOnly?: boolean;
  connection?: any;
};


const TextInput = styled.input`
  position: absolute;
  display: block;
  top:0;
  left:0;
  margin: 0;
  height: 100%;
  width: 100%;
  border: none;
  padding: 0;
  box-sizing: border-box;
  outline: none;
  padding: 0 10px;
`;

const Text: React.FC<IProps> = ({value, field: { maxLengthValue }, onChange, readOnly}) => {
  const onChangeHandler = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const eventVal = event.target.value;
    if (maxLengthValue && eventVal.length > maxLengthValue) return;
    onChange && onChange(eventVal);
  }, [onChange, maxLengthValue]);

  return <TextInput readOnly={readOnly} value={value} onChange={onChangeHandler} />;
}

export default Text;